import { Component, Input, OnInit } from '@angular/core';
import { PlatformType } from '@root/config';

@Component({
  selector: 'host-edit-inventory-form-item',
  templateUrl: './edit-inventory-form-item.component.html',
  styleUrls: ['./edit-inventory-form-item.component.scss'],
})
export class EditInventoryFormItemComponent implements OnInit {
  readonly Platform: typeof PlatformType = PlatformType;
  @Input() data;
  @Input() active = false;
  constructor() {}

  ngOnInit() {
    console.log(' this.data: ', this.data);
  }

  onBookingMinimumChange(data) {
    // if (data.status === 0) {
    //   this.data.minimum_stay = null;
    // } else {
    // }
    this.data.minimum_stay = data.value;
  }
}
